// types
import { DefaultConfigProps } from '@/types/base/config';

// ==============================|| THEME CONSTANT ||============================== //
export const API_URL = import.meta.env.VITE_APP_API_URL ?? 'http://localhost:3031/api/v1';
export const API_RESOURCE_URL = import.meta.env.VITE_APP_RESOURCE_URL ?? 'http://localhost:3031';
export const BASE_URL = import.meta.env.VITE_APP_URL ?? 'http://localhost:3000';
export const EXAMPLE_API_URL = import.meta.env.VITE_APP_API_URL_EXAMPLE_DATA ?? 'https://mock-data-api-nextjs.vercel.app';
export const DEFAULT_REDIRECT_URL = import.meta.env.VITE_APP_DEFAULT_REDIRECT_URL || 'https://google.com';
export const MinIO_URL = `${import.meta.env.VITE_APP_MINIO_URL}` || 'http://localhost:9002';
export const THAI_ID_CARD_READER = `${import.meta.env.VITE_APP_THAI_ID_CARD_READER}` || 'http://localhost:52347/getcarddata';
export const DIGITAL_SIGNATURE_ENDPOINT = `${import.meta.env.VITE_APP_DIGITAL_SIGNATURE_ENDPOINT}` || 'http://localhost:4001';
export const DIGITAL_SIGNATURE_DEFAULT_PIN = `${import.meta.env.VITE_APP_DIGITAL_SIGNATURE_DEFAULT_PIN}` || '';
export const PUBLIC_KEY_SHARE_DASHBOARD = `${import.meta.env.VITE_APP_PUBLIC_API_KEY}`;

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';

export const APP_DEFAULT_PATH = '/';
export const HORIZONTAL_MAX_ITEM = 7;
export const DRAWER_WIDTH = 280;
export const MINI_DRAWER_WIDTH = 90;
export const HEADER_HEIGHT = 74;

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_MAX_PAGE_SIZE = 100000;

export const MINIMUM_DATE_REQUIRED = 1900;

export const FONT_SIZE = ['6', '7', '8', '9', '10', '11', '12', '14', '16', '18', '24', '30', '36', '48', '60', '72', '96'];

export const FONT_FAMILY = [
  'Angsana New',
  'Anuphan',
  'IBM Plex Sans Thai',
  'Inter',
  'Sarabun',
  'TH Sarabun New',
  'TH SarabunPSK',
  'Prompt',
  'Poppins',
  'Public Sans',
  'Roboto'
];

export enum SimpleLayoutType {
  SIMPLE = 'simple',
  LANDING = 'landing'
}

export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark',
  AUTO = 'auto'
}

export enum MenuOrientation {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal'
}

export enum ThemeDirection {
  LTR = 'ltr',
  RTL = 'rtl'
}

export enum NavActionType {
  FUNCTION = 'function',
  LINK = 'link'
}

export enum Gender {
  MALE = 'Male',
  FEMALE = 'Female'
}

export enum DropzopType {
  DEFAULT = 'default',
  STANDARD = 'standard'
}

export enum LocalStorateKey {
  blueChartAccessToken = '7efd8f99-4fdf-4e3f-9c92-579ee8bfb7cd',
  blueChartRefreshToken = '1b1bee24-cbb8-4f75-a257-cb1abfbaf680',
  productId = 'aa1e49f6-95b7-4ee7-aa25-b48f51458edb',
  accountId = 'd7361968-2d76-4efc-b1bd-c0ae378a05f4',
  userfromBlueChart = 'f29fdc7d-4118-482a-96b6-3683af75c8e2',
  account = 'f6ea88ca-ce77-4c32-9a89-96ae5621cda8',
  redirect = '203a57b0-f42b-41ad-a344-ab5ef0cd6b1e'
}
export const MONEY_TYPE = [
  { label: 'งบอุดหนุน', value: 'addon' },
  { label: 'งบ พรบ', value: 'act' }
];
// ==============================|| THEME CONFIG ||============================== //
const config: DefaultConfigProps = {
  fontFamily: `Anuphan`,
  i18n: 'th', // default language here
  menuOrientation: MenuOrientation.VERTICAL,
  menuCaption: true,
  miniDrawer: false,
  container: false,
  mode: ThemeMode.LIGHT,
  presetColor: 'default',
  themeDirection: ThemeDirection.LTR,
  themeContrast: false
};

export default config;
